import React from 'react';
import { Button, IconButton, ImageList, ImageListItem, Popover, Typography } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useHorizontalScroll } from './useSideScroll';
import PropTypes from 'prop-types';
import "./ImageList.css"
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const listStyling = { 
  display: 'flex',
  overflowX: 'scroll',
  maxHeight: '340px',
  scrollbarWidth: 'thin',
  scrollbarColor: '#050A44 transparent',
}

const itemStyling = {
    height: 'auto !important;', 
    flexShrink: '0',
    '& .MuiImageListItem-img ': {
        width: 'auto !important', 
        borderRadius: '10px',
        borderColor: '#141419',
        border: 'thick solid',
        objectFit: 'scale-down',
    }

}

SingleLineImageListUpdate.propTypes   = {
    screenshotList: PropTypes.array,
    setComps: PropTypes.func,
    app: PropTypes.object
}



const BasicPopover = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    async function handleDelete(props, screenshots, setComps, app){
    
        const APILinksFetch = await fetch('/APILinks.json')
        const APILinks = await APILinksFetch.json()
        const response = await fetch(APILinks['deleteScreenshot'] + `screenshot=${props}`,{
            method: 'POST',
        })

        const deleteData = await response.json()

        if(deleteData['message'] === 'Deleted'){
            const res = await fetch(APILinks['getAppList'])
            const data = await res.json()

            const index = screenshots.indexOf(props)
            screenshots.splice(index, 1)
            
            app.screenshots = screenshots
            sessionStorage.setItem("app", JSON.stringify(app))
            setComps(data)
        }
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
        <IconButton sx={{padding: 0}} onClick={handleClick}>
            <DeleteForeverOutlinedIcon fontSize='medium'/>
        </IconButton>
        <Popover
            disableScrollLock={true}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
          
        >
            <Typography sx={{ p: 1}}>Do you want to delete this image?</Typography>
            <Button sx={{padding: 'auto',}} onClick={() => {handleDelete(props.imgDelete, props.screenshots, props.setComps, props.app)}}>Yes</Button>
        </Popover>
        </div>
    );
}

BasicPopover.propTypes ={
    imgDelete: PropTypes.string,
    setComps: PropTypes.func,
    screenshots: PropTypes.array,
    app: PropTypes.object
}

export default function SingleLineImageListUpdate(props){
    const scrollRef = useHorizontalScroll();
    
    return (
        <ImageList className='imageListDiv' ref={scrollRef} variant="woven" sx={listStyling} gap={15}>
            {props.screenshotList.map((item) => {
                item = encodeURIComponent(item)
                return (
                    <ImageListItem className='imgItem' sx={itemStyling} cols={1} rows={1} key={item}>
                        <img className="imgScreenshotUpdate" src={item} srcSet={`${item} 2x`} alt={"test"}/>
                        <BasicPopover imgDelete={item} screenshots={props.screenshotList} setComps={props.setComps} app={props.app} />
                    </ImageListItem>
                )
            })}
        </ImageList>
    );
}


